import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { withTranslation } from 'react-i18next';
import memoizeOne from 'memoize-one';

import * as dates from '../../helpers/dates';
import * as rampHelper from '../../helpers/ramp-helper';
import * as utils from '../../helpers/utils';
import * as mobileHelper from '../../helpers/mobile';
import {
  GridButton,
  GridDateTimePicker,
  GridIconButton,
  Placeholder,
} from '../Form/shared';
import { FormBlock, FormNumberField, FormSelect, FormTextField } from '../Form';
import styles from './styles';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid2';
import withDeletePopup from '../withDeletePopup';

const initialRampValue = {
  start: null,
  end: null,
  amount: 1,
};

const getServiceItems = memoizeOne((services, t) =>
  rampHelper
    .getNotFixedRampServices(services)
    .map(service => ({
      name: t(service.name),
      value: service._id,
    }))
    .sort(utils.makeCompareStrings('name'))
);

class Ramp extends Component {
  handleAddClick = () => {
    const { setFieldValue, values, services } = this.props;
    setFieldValue(`outbound.ramp[${values.outbound.ramp.length}]`, {
      rampId: rampHelper.getNotFixedRampServices(services)[0]._id,
      ...initialRampValue,
    });
  };

  handleDeleteClick = index => {
    const { setFieldValue, values } = this.props;
    setFieldValue(`outbound.ramp`, [
      ...values.outbound.ramp.slice(0, index),
      ...values.outbound.ramp.slice(index + 1),
    ]);
  };

  render() {
    const { values, services, onDeleteConfirmationDialogOpen, t } = this.props;
    const filteredServices = rampHelper.prepareRampServices(services, values);
    const serviceItems = getServiceItems(filteredServices, t);
    const isPortrait = mobileHelper.isPortrait();
    return (
      <>
        {rampHelper
          .getFixedRampServices(filteredServices)
          .map(service => ({
            ...service,
            name: t(service.name),
          }))
          .map((ramp) => {
          return (
            <FormBlock variant="contained" key={ramp._id}>
              <Grid size={{ xs: 5 }}>
                <FormLabel>{ramp.name}</FormLabel>
              </Grid>
              {ramp.isCountable && (
                <FormNumberField
                  size={2}
                  name={`outbound.fixedRamp.${ramp._id}.amount`}
                    label={t('Qty')}
                  positiveInteger
                />
              )}
              {ramp.isTimeBased && (
                <>
                  <GridDateTimePicker
                    xs={2}
                    name={`outbound.fixedRamp.${ramp._id}.start`}
                      label={t('Start')}
                    format={dates.TIME_FORMAT}
                  />
                  <GridDateTimePicker
                    xs={2}
                    name={`outbound.fixedRamp.${ramp._id}.end`}
                      label={t('End')}
                    format={dates.TIME_FORMAT}
                  />
                </>
              )}
            </FormBlock>
          );
        })}
        Additional services
        {values.outbound.ramp.map((r, i) => {
          const rampService = rampHelper.getRampServiceById(
            filteredServices,
            r.rampId
          );
          return rampService ? (
            <FormBlock key={`ramp${i}`} variant="contained">
              <FormSelect
                fullWidth={isPortrait}
                size={5}
                name={`outbound.ramp[${i}].rampId`}
                items={serviceItems}
              />
              <FormNumberField
                size={2}
                name={`outbound.ramp[${i}].amount`}
                label="Qty"
                positiveInteger
              />
              {
                // TODO maybe update ramp collection with field name and type to support automatic field generation
                rampService.name === 'A/C Deicing' ? (
                  <>
                    <FormTextField
                      size={3}
                      name={`outbound.ramp[${i}].value`}
                      label="Fluid type"
                      positiveInteger
                    />
                    <Placeholder xs={isPortrait ? 6 : 1} />
                  </>
                ) : rampService.isTimeBased ? (
                  <>
                    <GridDateTimePicker
                      xs={2}
                      name={`outbound.ramp[${i}].start`}
                      label="Start"
                      format={dates.TIME_FORMAT}
                    />
                    <GridDateTimePicker
                      xs={2}
                      name={`outbound.ramp[${i}].end`}
                      label="End"
                      format={dates.TIME_FORMAT}
                    />
                    {isPortrait ? <Placeholder xs={5} /> : null}
                  </>
                ) : (
                  <Placeholder xs={isPortrait ? 9 : 4} />
                )
              }
              <GridIconButton
                edge={'end'}
                xs={1}
                icon="delete"
                onClick={() =>
                  onDeleteConfirmationDialogOpen(
                    this.handleDeleteClick.bind(null, i)
                  )
                }
              />
            </FormBlock>
          ) : null;
        })}
        <FormBlock>
          <Placeholder xs={9} />
          <GridButton
            variant="contained"
            color="primary"
            xs={3}
            label="ADD"
            onClick={this.handleAddClick}
          />
        </FormBlock>
      </>
    );
  }
}

export default withTranslation()(withStyles(styles)(withDeletePopup(Ramp)));
